import { Stack } from "@mui/material"
import { AxiosResponse } from "axios"
import { useQueryClient } from "react-query"
import { useLocation } from "react-router-dom"
import { GradientDivider } from "styles/common/box"
import { IUserMe } from "ts/interfaces/User"
import { isTeacher } from "utils/roleCheck"

import { AdminAside, ClassAside } from "./asideOptions"
import HelperOption from "./helperOption"
import HiddenClass from "./hiddenClass/HiddenClass"
import TabNavigation from "./tabNavigation"

const Navigation = () => {
  const queryClient = useQueryClient()
  const { pathname } = useLocation()
  const isAdminRoute = pathname.startsWith("/admin")

  const isTeacherAdmin = () => {
    const cacheDataUserMe = queryClient.getQueryData<AxiosResponse<IUserMe>>([
      "userMe",
    ])
    if (cacheDataUserMe && isTeacher(cacheDataUserMe?.data.user)) {
      return cacheDataUserMe?.data.user.is_school_admin
    }
    return false
  }

  return (
    <Stack justifyContent="space-between" height="100%">
      <Stack flex="1 1 auto" component="nav">
        {isTeacherAdmin() ? (
          <TabNavigation
            render={(isAdmin) => (isAdmin ? <AdminAside /> : <ClassAside />)}
          />
        ) : (
          <ClassAside />
        )}
      </Stack>
      <GradientDivider />
      {!isAdminRoute && <HiddenClass />}
      <HelperOption />
    </Stack>
  )
}

export default Navigation
